export const SET_CURRENT_FAQ_TAB = 'SET_CURRENT_FAQ_TAB';
export const SET_IS_ERROR_ON_EDIT_PROFILE = 'SET_IS_ERROR_ON_EDIT_PROFILE';